import Portal from '../../utils/Portal';
import styles from './style.module.css'

export default function EmptyModal({onAction,onClose,children}){
    function handleClickOutside(event) {
        if(event.target.classList.contains(styles['wrap'])){
            onClose();
        }
    }

    return(
        <Portal><div className={styles['wrap']} onClick={handleClickOutside}>
                {children}
        </div></Portal>
    )
}